/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import Page from "@insite/mobius/Page";
import * as React from "react";

type KnowledgeCenterProps = PageProps;

const KnowledgeCenterDetails: React.FC<KnowledgeCenterProps> = ({ id }) => {
    return (
        <Page>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const knowledgeCenterDetailsPageModule: PageModule = {
    component: KnowledgeCenterDetails,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default knowledgeCenterDetailsPageModule;

export const KnowledgeCenterDetailsPageContext = "KnowledgeCenterDetails";
